module.exports = __webpack_public_path__ + "static/media/StrainThreshold.053a03be.svg";